import { render, staticRenderFns } from "./AnswerList.vue?vue&type=template&id=91e6cfa2&scoped=true&"
import script from "./AnswerList.vue?vue&type=script&lang=js&"
export * from "./AnswerList.vue?vue&type=script&lang=js&"
import style0 from "./AnswerList.vue?vue&type=style&index=0&id=91e6cfa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e6cfa2",
  null
  
)

export default component.exports